import axios from 'axios';

// Dual-API: submit to both rvrex (CRM) and nurexify (ERP) simultaneously
const api1 = axios.create({ baseURL: "https://api.rvrex.com/" });
const api2 = axios.create({ baseURL: "https://infra-api.nurexify.com/" });

const Apis = () => {

    const saveContactFormdata = async (input_data) => {
        const payload = {};
        if (input_data instanceof FormData) {
            input_data.forEach((value, key) => { payload[key] = value; });
        } else {
            Object.assign(payload, input_data);
        }
        if (!payload.source) payload.source = "Aspiration";

        const config = { headers: { "Content-Type": "application/json" } };
        const [res1] = await Promise.all([
            api1.post("api/storefront/submitContact", payload, config),
            // api2.post("api/storefront/submitContact", payload, config),
        ]);
        return res1;
    };

    return { saveContactFormdata };
};

export default Apis;
